module.exports = __webpack_public_path__ + "static/media/bar-chart-new.d65fd445.png";